import { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { getSchoolByCode, getSchoolsData } from "../../api";
const SchoolInput = ({ school, onChange, setError, className }) => {
  const queryClient = useQueryClient();
  const [filter, setFilter] = useState({ grade: "", sido: "", code: "" });
  const [gugun, setGugun] = useState(null);
  const [options, setDataList] = useState({
    grade: [],
    sido: [],
    gugun: [],
    school: [],
  });
  const [data, setData] = useState({
    code: "",
    grade: "",
    school: { name: "", code: "" },
    gugun: { label: "", value: "" },
    sido: { label: "", value: "" },
  });

  const findSchoolData = async (code) => {
    const res = await queryClient.fetchQuery(`info/school/${code}`, {
      queryFn: () => getSchoolByCode({ code }),
    });
    const { result, data: d, error: e } = res;
    if (result) {
      setData(d);
      setFilter({ grade: d.grade, sido: d.sido.value, code: d.code });
    }
    if (e) {
      setError && setError(e);
    }
  };

  const fetchSchoolsData = async ({ grade, code }) => {
    const qid = ["info", "school"];
    if (grade) qid.push(grade);
    if (code) qid.push(code);
    const res = await queryClient.fetchQuery(qid.join("/"), {
      queryFn: () => getSchoolsData({ grade, code }),
    });
    const { result, data, error: e } = res;
    if (result) {
      const { grade: g, loc: l, school: s } = data;
      let grade = [];
      let sido = [];
      let school = [];
      let gugun = [];
      if (g.res && g.list) {
        const glist = g.list.map((o) => {
          const [key, value] = Object.entries(o)[0];
          return { key, value };
        });
        grade = glist;
      }
      if (l.res && l.list) {
        const llist = l.list.map(({ sido: { label: value, value: key } }) => ({
          key,
          value,
        }));
        const gugunData = l.list.reduce(
          (acc, { sido: { value }, gugun }) => ({ ...acc, [value]: gugun }),
          {}
        );
        if (school) {
          gugun = gugunData[filter.sido];
        }
        setGugun(gugunData);
        sido = llist;
      }
      if (s.res && s.list) {
        school = s.list;
      }
      setDataList({ grade, sido, gugun, school });
    }
    if (e) {
      setError(e);
    }
  };

  const handleChange = (e) => {
    const { value: val, id: target } = e.target;
    if (target === "grade") {
      setData({
        grade: val,
        code: "",
        school: { name: "", code: "" },
        gugun: { label: "", value: "" },
        sido: { label: "", value: "" },
      });
      setFilter({ ...filter, grade: val, code: "" });
    } else if (target === "sido") {
      setData({ ...data, sido: { label: "", value: val } });
      setFilter({ ...filter, sido: val, code: "" });
      setDataList({ ...options, gugun: gugun[val] });
    } else if (target === "gugun") {
      setData({
        ...data,
        code: `${filter.sido}${val}`,
        gugun: { label: "", value: val },
      });
      setFilter({ ...filter, code: `${filter.sido}_${val}` });
    } else {
      const item = options.school.find(({ code }) => code === val);
      setData({ ...data, school: item });
      onChange({ target: { ...e.target, id: target, value: item } });
    }
  };

  useEffect(() => {
    if (school && "code" in school && school.code) {
      findSchoolData(school.code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [school]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    fetchSchoolsData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <>
      <div className="form-control w-full">
        {!filter.grade && (
          <span className="text-sm mt-1 text-left">
            재학중인 학교의 분류를 선택하세요.
          </span>
        )}
        <select
          id="grade"
          className={`select select-bordered w-full font-normal ${
            className || ""
          }`}
          onChange={handleChange}
          value={data.grade}
        >
          <option>분류</option>
          {options.grade.map(({ key, value }) => (
            <option value={key} key={key}>
              {value}
            </option>
          ))}
        </select>
      </div>
      {filter.grade && (
        <div className="form-control">
          <select
            id="sido"
            className={`select select-bordered w-full font-normal ${
              className || ""
            }`}
            onChange={handleChange}
            value={data.sido.value}
          >
            <option>시/도</option>
            {options.sido.map(({ key, value }) => (
              <option value={key} key={`sido${key}`}>
                {value}
              </option>
            ))}
          </select>
          {!filter.sido && (
            <span className="text-sm mt-1 text-left">
              학교가 소재한 시/도를 선택하세요.
            </span>
          )}
        </div>
      )}
      {filter.sido && (
        <div className="form-control">
          <select
            id="gugun"
            className={`select select-bordered w-full font-normal ${
              className || ""
            }`}
            onChange={handleChange}
            value={data.gugun.value}
          >
            <option>시/군/구을(를) 선택하세요.</option>
            {options.gugun.map(({ label, value }) => (
              <option value={value} key={`gugun${value}`}>
                {label}
              </option>
            ))}
          </select>
          {!filter.sido && (
            <span className="text-sm mt-1 text-left">
              학교가 소재한 시/군/구을(를) 선택하세요.
            </span>
          )}
        </div>
      )}
      {filter.code && (
        <div className="form-control">
          <select
            id="school"
            className={`select select-bordered w-full font-normal ${
              className || ""
            }${school ? " border-primary" : ""}`}
            onChange={handleChange}
            value={data.school.code}
          >
            <option>학교</option>
            {options.school.map(({ code, name }) => (
              <option value={code} name={name} id={name} key={code}>
                {name}
              </option>
            ))}
          </select>
          {!school && (
            <span className="text-sm mt-1 text-left">
              학교 이름을 선택하세요.
            </span>
          )}
        </div>
      )}
    </>
  );
};

export default SchoolInput;
